import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

export const PrivateRoute = ({ children }) => {
  const { accessToken, roles } = useSelector((state) => state.auth);
  const location = useLocation();

  if (!accessToken || !roles.includes("ROLE_ADMIN")) {
    // Redirect to login page if not authenticated or not admin
    return <Navigate to="/admin" state={{ from: location }} replace />;
  }

  return children;
};